import { render } from "./pricing-page.vue?vue&type=template&id=55a9da38"
import script from "./pricing-page.vue?vue&type=script&lang=js"
export * from "./pricing-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__